// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowSuggestion-cls1_hbs","cls2":"BulkFollowSuggestion-cls2_8sb BulkFollowSuggestion-cls1_hbs","suggested":"BulkFollowSuggestion-suggested_16B"};